import { Icon } from 'src/general/Icons/Icon';
import { FilterName } from 'src/plp/components/FilterName/FilterName';

import { FilterHierarchyFieldsGroupOption, PlpHierarchyFilterItemProps } from '../PlpFilters.type';
import { FilterHierarchyFieldsGroup } from '../components/Fields/FilterHierarchyFieldsGroup';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

type Props = PlpHierarchyFilterItemProps<FilterHierarchyFieldsGroupOption>;

export const FilterBodyType = ({ options, currentFilters, index, showNotificationBadge, ...props }: Props) => {
  const id = 'bodyType';
  const header = <FilterName icon={<Icon name="body-type" />} label="Body type" showNotificationBadge={showNotificationBadge} />;
  const content = (
    <FilterHierarchyFieldsGroup options={options} subCategoryLabel="size" currentFilters={currentFilters} {...props} />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
